<template>
  <div class="notification-banner">
    <div class="notification-content">
      <span class="notification-text"
        >The Member Portal is currently transitioning to OHI.org and you may experience issues while
        browsing. Please contact us if you have any issues with invoices or portal features.</span
      >
      <button class="notification-close" @click="closeNotification">X</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeNotification() {
      // Emit an event or perform an action to close the notification
      this.$emit('close');
    },
  },
};
</script>

<style>
.notification-banner {
  margin: 20px 0;
  width: 100%;
  background-color: #9cdeff;
  color: #212529;
  padding: 28px;
}

.notification-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.notification-text {
  font-weight: bold;
  font-size: 14px;
}

.notification-close {
  background: none;
  border: none;
  color: #212529;
  cursor: pointer;
}
</style>
